(function () {
  'use strict';

  angular
    .module('perfis')
    .factory('Perfis', PerfisService)
    .factory('PerfisPublic', PerfisPublicService);

  function PerfisService(Restangular) {
    return Restangular.service('auth/perfis');
  }

  function PerfisPublicService(Restangular) {
    return Restangular.service('auth/perfis/public');
  }
}());
